export const SIGN_IN_START = 'auth/loginStart';
export const SIGN_IN_DONE = 'auth/loginDone';
export const SIGN_IN_FAIL = 'auth/loginFail';

export const RESET_PASSWORD_START = 'auth/resetPasswordStart';
export const RESET_PASSWORD_DONE = 'auth/resetPasswordDone';
export const RESET_PASSWORD_FAIL = 'auth/resetPasswordFail';